'use strict';

var Logger = {};

var showLog = function (prefix, message, color) {
    console.log('%c[' + prefix + ']', 'color: ' + color, message);
};

var showDebugMessages = function () {
    return 'TC_DEBUG' in window && TC_DEBUG;
};

Logger.debug = function (message) {
    if (showDebugMessages()) {
        showLog('D', message, 'gray');
    }
};

Logger.info = function (message) {
    if (showDebugMessages()) {
        showLog('I', message, 'blue');
    }
};

Logger.warning = function (message) {
    showLog('W', message, 'gold');
};

Logger.error = function (message) {
    showLog('E', message, 'red');
};

Logger.schema = function (message) {
    showLog('S', message, 'green');
};

Logger.assert = function (expression) {
    if (!expression) {
        showLog('Assertion failed', '', 'red');
        debugger;
    }
};

Logger.assertEach = function (list, assertion) {
    Logger.assert(!!list);
    Logger.assert(typeof list === 'object');

    var faultyElement = _.find(list, function (index, element) {
        return !assertion(index, element);
    });

    if (faultyElement) {
        showLog('Assertion failed', '', 'red');
        debugger;
    }
};

module.exports = Logger;
